<template>
    <div>
        <a-form layout="horizontal" :label-col="labelCol" :wrapper-col="wrapperCol"  ref="ruleForm" labelAlign="right" :model="form" :rules="rules">
            <!--可编辑区域 start-->
            <div  class="hidden">
                <!-- <div > -->
                <a-form-item label="主键ID" name="id">
                    <a-input v-model:value="form.id" placeholder="请输入主键ID" />
                </a-form-item>
                <a-form-item label="流程ID" name="processId">
                    <a-input v-model:value="form.processId" placeholder="请输入流程ID" />
                </a-form-item>
            </div>

            <a-row :gutter="20">
                <a-col :span="12">
                    <a-form-item label="创新平台" name="applicationIndustry">
                        <a-input v-model:value="form.applicationIndustry" placeholder="请输入创新平台" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="项目联系人" name="projectContact">
                        <a-input v-model:value="form.projectContact" placeholder="请输入项目联系人" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="项目联系人电话" name="phone">
                        <a-input style="width:100%" v-model:value="form.phone" :min="0" :precision="0"  placeholder="项目联系人电话" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="项目联系人传真" name="facsimile">
                        <a-input v-model:value="form.facsimile" placeholder="请输入项目联系人传真" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="项目联系人邮箱" name="email">
                        <a-input v-model:value="form.email" placeholder="请输入项目联系人邮箱" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="本科以上学历人数" name="graduateNumber">
                        <a-input-number style="width:100%" v-model:value="form.graduateNumber" :min="0" :precision="0"   placeholder="请输入本科以上学历人数"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="科研研发人员" name="researcherNumber">
                        <a-input-number style="width:100%" v-model:value="form.researcherNumber" :min="0" :precision="0"   placeholder="请输入科研研发人员"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="转化和推广人员" name="extensionWorker">
                        <a-input-number style="width:100%" v-model:value="form.extensionWorker" :min="0" :precision="0"   placeholder="请输入转化和推广人员"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="上年末总资产(万元)" name="oldProperty">
                        <a-input-number style="width:100%" v-model:value="form.oldProperty" :min="0" :precision="0"   placeholder="请输入上年末总资产"/>
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="资产负责率" name="debtRatio">
                        <a-input v-model:value="form.debtRatio" placeholder="请输入资产负责率" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="上年度主营业务收入(万元)" name="operatingIncome">
                        <a-input-number style="width:100%" v-model:value="form.operatingIncome" :min="0" :precision="0"  placeholder="请输入上年度主营业务收入" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="上年度利税" name="oldProfitTax">
                        <a-input v-model:value="form.oldProfitTax" placeholder="请输入上年度利税" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="上年度创汇（万元）" name="obtain">
                        <a-input v-model:value="form.obtain" placeholder="请输入上年度创汇（万元）" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="科技成果类型" name="achievementType">
                        <a-input v-model:value="form.achievementType" placeholder="请输入科技成果类型" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="技术水平" name="technologyLevel">
                        <a-input v-model:value="form.technologyLevel" placeholder="请输入技术水平" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="技术来源" name="technologySource">
                        <a-input v-model:value="form.technologySource" placeholder="请输入技术来源" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="一级学科代码" name="oneSubjectCode">
                        <a-input v-model:value="form.oneSubjectCode" placeholder="请输入一级学科代码" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="一级学科名称" name="oneSubjectName">
                        <a-input v-model:value="form.oneSubjectName" placeholder="请输入一级学科名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="二级学科代码" name="twoSubjectCode">
                        <a-input v-model:value="form.twoSubjectCode" placeholder="请输入二级学科代码" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="二级学科名称" name="twoSubjectName">
                        <a-input v-model:value="form.twoSubjectName" placeholder="请输入二级学科名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="三级学科代码" name="threeSubjectCode">
                        <a-input v-model:value="form.threeSubjectCode" placeholder="请输入三级学科代码" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="三级学科名称" name="threeSubjectName">
                        <a-input v-model:value="form.threeSubjectName" placeholder="请输入三级学科名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="一级行业名称" name="oneFirmName">
                        <a-input v-model:value="form.oneFirmName" placeholder="请输入一级行业名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="二级行业名称" name="twoFirmName">
                        <a-input v-model:value="form.twoFirmName" placeholder="请输入二级行业名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="12">
                    <a-form-item label="三级行业名称" name="threeFirmName">
                        <a-input v-model:value="form.threeFirmName" placeholder="请输入三级行业名称" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :labelCol="5" label="项目实施的必要性、重要性、国内现在状" name="actuality">
                        <a-textarea v-model:value="form.actuality" placeholder="请输入项目实施的必要性、重要性、国内现在状" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :labelCol="13" label="实施项目的科学成果的先进性、成熟性、适用性及知识产权情况" name="scientificPayoff">
                        <a-textarea v-model:value="form.scientificPayoff" placeholder="请输入实施项目的科学成果的先进性、成熟性、适用性及知识产权情况" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :labelCol="13" label="项目实施的基础条件和优势、转化推广示范基地已有基础及建设目标" name="constructionGoals">
                        <a-textarea v-model:value="form.constructionGoals" placeholder="请输入项目实施的基础条件和优势、转化推广示范基地已有基础及建设目标" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <a-col :span="24">
                    <a-form-item :labelCol="13" label="项目实施的主要内容、目标、项目转化推广模式、措施、组织及合作方式" name="cooperationSituation">
                        <a-textarea v-model:value="form.cooperationSituation" placeholder="请输入项目实施的主要内容、目标、项目转化推广模式、措施、组织及合作方式" :auto-size="{minRows:3,maxRows:6}" />
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="12">
                    <a-form-item label="流程id" name="processId">
                        <a-input v-model:value="form.processId" placeholder="请输入流程id" />
                    </a-form-item>
                </a-col> -->
            </a-row>
            <!--可编辑区域 end-->
        </a-form>
    </div>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import {formMixin} from "@/mixins";
import {projectAchievement} from "@/api/TechnologieprojekteApply";
// import YearPicker from "@/components/form/datePicker/YearPicker";
import {postAction,postJson} from "@/utils/http/service";
import {filterObj} from "@/utils/util";
import store from '@/store';


export default {
    name: "项目基本信息",
    components: {},

    mixins: [formMixin],
    data() {
        return {
            oneClassification: null,
            labelCol: { span: 12 },
            wrapperCol: { span: 14 },
            form: {
                id: null,
                processId: this.$route.query.type,
                applicationIndustry: null,
                    projectContact: null,
                    phone: null,
                    facsimile: null,
                    email: null,
                    graduateNumber: null,
                    researcherNumber: null,
                    extensionWorker: null,
                    oldProperty: null,
                    debtRatio: null,
                    operatingIncome: null,
                    oldProfitTax: null,
                    obtain: null,
                    achievementType: null,
                    technologyLevel: null,
                    technologySource: null,
                    oneSubjectCode: null,
                    oneSubjectName: null,
                    twoSubjectCode: null,
                    twoSubjectName: null,
                    threeSubjectCode: null,
                    threeSubjectName: null,
                    oneFirmName: null,
                    twoFirmName: null,
                    threeFirmName: null,
                    actuality: null,
                    scientificPayoff: null,
                    constructionGoals: null,
                    cooperationSituation: null,
            },
            rules: {
                id: [],
                projectName: [
                    dataCheck.required({}),
                ],
                    applicationIndustry: [
                        dataCheck.required({}),
                    ],
                    projectContact: [
                        dataCheck.required({}),
                    ],
                    phone: [
                        dataCheck.required({}),
                        dataCheck.phone,
                    ],
                    facsimile: [
                        dataCheck.required({}),
                    ],
                    email: [
                        dataCheck.required({}),
                    ],
                    graduateNumber: [
                        dataCheck.required({
                            type: "number"
                        }),
                    ],
                    researcherNumber: [
                        dataCheck.required({
                            type: "number"
                        }),
                    ],
                    extensionWorker: [
                        dataCheck.required({
                            type: "number"
                        }),
                    ],
                    oldProperty: [
                        dataCheck.required({
                            type: "number"
                        }),
                    ],
                    debtRatio: [
                        dataCheck.required({}),
                    ],
                    operatingIncome: [
                        dataCheck.required({
                            type: "number"
                        }),
                    ],
                    oldProfitTax: [
                        dataCheck.required({}),
                    ],
                    obtain: [
                        dataCheck.required({}),
                    ],
                    achievementType: [
                        dataCheck.required({}),
                    ],
                    technologyLevel: [
                        dataCheck.required({}),
                    ],
                    technologySource: [
                        dataCheck.required({}),
                    ],
                    oneSubjectCode: [
                        dataCheck.required({}),
                    ],
                    oneSubjectName: [
                        dataCheck.required({}),
                    ],
                    twoSubjectCode: [
                        dataCheck.required({}),
                    ],
                    twoSubjectName: [
                        dataCheck.required({}),
                    ],
                    threeSubjectCode: [
                        dataCheck.required({}),
                    ],
                    threeSubjectName: [
                        dataCheck.required({}),
                    ],
                    oneFirmName: [
                        dataCheck.required({}),
                    ],
                    twoFirmName: [
                        dataCheck.required({}),
                    ],
                    threeFirmName: [
                        dataCheck.required({}),
                    ],
                    actuality: [
                        dataCheck.required({}),
                    ],
                    scientificPayoff: [
                        dataCheck.required({}),
                    ],
                    constructionGoals: [
                        dataCheck.required({}),
                    ],
                    cooperationSituation: [
                        dataCheck.required({}),
                    ],
            },

            options: [],

        }
    },
    
    computed: {
            submitUrl() {
                return projectAchievement.saveOrUpdate
            }
        },
    mounted() {
        if(this.$route.query.id){
            this.onEdit()
        }
        this.oneClassification=this.$route.query.oneClassification
    },
    methods: {
        onEdit() {
            this.getAction({
                url: projectAchievement.detailByProject,
                params: { 
                    projectId: store.getters.TechnologieTypeId.projectId,
                    classification: store.getters.TechnologieTypeId.classification,
                 }
            }).then(res => {
                this.form = res
                this.$parent.$parent.$parent.$parent.postData(res.oneClassification,res.id)
            })
        },
        /*提交表单操作*/
        onSubmit(res) {
            if(res){
                this.form.projectId = res
            }
            console.log('科技成果扩展')
            if (!this.submitUrl) {
                this.$notification.warning({
                    message: '提示',
                    description: '请设置表单操作url地址',
                });
            } else {
                this.$refs.ruleForm
                    .validate()
                    .then(() => {
                        this.confirmLoading = true;
                        let params = this.transformParams
                            ? this.transformParams(this.form)
                            : this.form;
                            let action;
                        /*后台请求*/
                        if(this.submitType == 'json'){
                            action = postJson({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }else{
                            action=  postAction({
                                url: this.submitUrl,
                                params: filterObj(this.getSubmitParams(params)),
                                method: this.postMethod,
                                returnMsg: true
                            })
                        }
                        action.then((res) => {
                            this.$parent.$parent.postData(res.data.classification,res.data.projectId)
                            this.confirmLoading = false;
                            this.$notification.success({
                                message: '提示',
                                description: res.msg || '操作成功',
                            });
                            if (this.onSuccessFn) {
                                this.onSuccessFn(res);
                            }
                            if (this.isModal) {
                                this.$emit('finish');
                                this.onClose();
                            }
                        }).catch(() => {
                            this.confirmLoading = false;
                        })
                    })
                    .catch(error => {
                        if(error.errorFields.length){
                            this.$notification.error({
                                message: '请检查必填项，必填项目不能不填',
                            });
                            this.$parent.$parent.$parent.$parent.errorSet()
                        }
                        window.console.log('error', error);
                    });
            }
        },
    },
}
</script>
<style scoped lang="less">
:deep(.ant-modal-body) {
    height:100vh!important;
    max-height: 100vh!important;
     }
</style>
